import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  JSON: any;
  NonNegativeInt: number;
  PositiveInt: number;
  StringOrInt: any;
};

export type AdminGroup = {
  __typename?: 'AdminGroup';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  memberCount?: Maybe<Scalars['NonNegativeInt']>;
  members: Array<AdminUser>;
  name: Scalars['String'];
  resourceRoles?: Maybe<ResourceRoles>;
  updatedAt: Scalars['DateTime'];
};

export type AdminGroupAdminUserMutationInput = {
  adminGroupId: Scalars['String'];
  adminUserIds: Array<Scalars['String']>;
};

export type AdminGroupResourceRolesMutationInput = {
  adminGroupId: Scalars['String'];
  resourceRoles: ResourceRoleInput;
};

export type AdminGroupResourceRolesMutationResult = {
  __typename?: 'AdminGroupResourceRolesMutationResult';
  adminGroupId: Scalars['String'];
};

export type AdminGroupsResult = {
  __typename?: 'AdminGroupsResult';
  data: Array<AdminGroup>;
  meta: ResultMeta;
};

export enum AdminLanguage {
  En = 'en',
  Fi = 'fi',
  Sv = 'sv'
}

export type AdminUser = {
  __typename?: 'AdminUser';
  adminAuthenticationProviderId: Scalars['String'];
  adminGroups: AdminGroupsResult;
  createdAt: Scalars['DateTime'];
  externalHumanReadableUsername: Scalars['String'];
  externalId: Scalars['String'];
  externalOrganizationId: Scalars['String'];
  externalRealName: Scalars['String'];
  globalRoles: Array<Scalars['String']>;
  id: Scalars['String'];
  isSuperadmin: Scalars['Boolean'];
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']>;
};


export type AdminUserAdminGroupsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type AdminUsersResult = {
  __typename?: 'AdminUsersResult';
  data: Array<AdminUser>;
  meta: ResultMeta;
};

export type AssessmentOrder = {
  __typename?: 'AssessmentOrder';
  endTimestamp?: Maybe<Scalars['DateTime']>;
  groups: Array<Group>;
  id: Scalars['String'];
  messages: Array<ScheduledMessage>;
  name: Scalars['String'];
  startTimestamp: Scalars['DateTime'];
  surveyCompletedCount: Scalars['PositiveInt'];
  surveyMetaModules: Array<SurveyMetaModule>;
  users: UserResult;
};


export type AssessmentOrderUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type AssessmentOrderFilterInput = {
  groupId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

export type AssessmentOrderUser = {
  __typename?: 'AssessmentOrderUser';
  uuid: Scalars['String'];
};

export type AssessmentOrdersResult = {
  __typename?: 'AssessmentOrdersResult';
  data: Array<AssessmentOrder>;
  meta: ResultMeta;
};

export type Authorization = {
  __typename?: 'Authorization';
  authorized: Scalars['Boolean'];
  queryId: Scalars['String'];
};

export type AuthorizationRequest = {
  action: Scalars['String'];
  resource?: InputMaybe<OsoResource>;
  resourceType: Scalars['String'];
};

export type AuthorizeResourceTypeRequest = {
  action: Scalars['String'];
  queryId: Scalars['String'];
  resourceType: Scalars['String'];
};

export type AvailableResourceRoles = {
  __typename?: 'AvailableResourceRoles';
  companyGroups: Array<Scalars['String']>;
};

export type BasicResults = {
  __typename?: 'BasicResults';
  assessmentOrderId: Scalars['String'];
  challengeSectors: Array<SectorResult>;
  cluster?: Maybe<Cluster>;
  email: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  riskResults: Array<RiskResult>;
  sectorResults: Array<SectorResult>;
  strengthSectors: Array<SectorResult>;
  timestamp: Scalars['DateTime'];
  userUuid: Scalars['String'];
  virtaScore?: Maybe<Scalars['PositiveInt']>;
  workAbilityChallenge: Scalars['String'];
};

export type BasicResultsResult = {
  __typename?: 'BasicResultsResult';
  data?: Maybe<Array<BasicResults>>;
  meta: ResultMeta;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Cluster = {
  __typename?: 'Cluster';
  key: Scalars['String'];
  severity: Severity;
};

export type CreateAdminGroupInput = {
  name: Scalars['String'];
};

export type CreateAssessmentOrderInput = {
  companyGroupIds: Array<Scalars['String']>;
  endTimestamp: Scalars['DateTime'];
  name: Scalars['String'];
  startTimestamp: Scalars['DateTime'];
  surveyModules: Array<SurveyMetamoduleModulePair>;
};

export type CreateGroupInput = {
  company: Scalars['String'];
  department?: InputMaybe<Scalars['String']>;
  emailFilter?: InputMaybe<Scalars['String']>;
  endTimestamp: Scalars['DateTime'];
  startTimestamp: Scalars['DateTime'];
};

export type DeleteAdminGroupResult = {
  __typename?: 'DeleteAdminGroupResult';
  deletedAdminGroupId: Scalars['String'];
};

export type DeleteAdminUserResult = {
  __typename?: 'DeleteAdminUserResult';
  id: Scalars['String'];
};

export type DeleteScheduledMessagesInput = {
  ids: Array<Scalars['PositiveInt']>;
};

export type DeleteScheduledMessagesResponse = {
  __typename?: 'DeleteScheduledMessagesResponse';
  ids: Array<Scalars['PositiveInt']>;
};

export type DeleteUserResult = {
  __typename?: 'DeleteUserResult';
  userUuid: Scalars['String'];
};

export type DetailedResults = {
  __typename?: 'DetailedResults';
  assessmentOrderId: Scalars['String'];
  challengeSectors: Array<SectorResult>;
  cluster?: Maybe<Cluster>;
  email: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['PositiveInt'];
  questionAnswers: Array<QuestionAnswer>;
  riskResults: Array<RiskResult>;
  sectorResults: Array<SectorResult>;
  strengthSectors: Array<SectorResult>;
  surveyModules: Array<SurveyModule>;
  timestamp: Scalars['DateTime'];
  userUuid: Scalars['String'];
  virtaScore?: Maybe<Scalars['PositiveInt']>;
  workAbilityChallenge: Scalars['String'];
};

export type DetailedResultsResult = {
  __typename?: 'DetailedResultsResult';
  data?: Maybe<Array<DetailedResults>>;
  meta: ResultMeta;
};

export type DocumentSection = {
  __typename?: 'DocumentSection';
  content: DocumentSectionContent;
  id: Scalars['ID'];
};

export type DocumentSectionContent = {
  __typename?: 'DocumentSectionContent';
  value: Scalars['JSON'];
};

export type EndUserAssessmentOrder = {
  __typename?: 'EndUserAssessmentOrder';
  closed: Scalars['Boolean'];
  features: EndUserAssessmentOrderFeatures;
  id: Scalars['ID'];
  name: Scalars['String'];
  personal: Scalars['Boolean'];
  progressPercentage: Scalars['Float'];
  result: EndUserSurveyResult;
  resultHistory: Array<EndUserSurveyResult>;
  trial: Scalars['Boolean'];
  user: AssessmentOrderUser;
};


export type EndUserAssessmentOrderResultArgs = {
  language: Language;
  resultId?: InputMaybe<Scalars['PositiveInt']>;
};


export type EndUserAssessmentOrderResultHistoryArgs = {
  language: Language;
};

export type EndUserAssessmentOrderFeatures = {
  __typename?: 'EndUserAssessmentOrderFeatures';
  showResultsToEndUser: Scalars['Boolean'];
  surveyFlowVariant: SurveyFlowVariant;
};

export type EndUserSurveyResult = {
  __typename?: 'EndUserSurveyResult';
  completed: Scalars['Boolean'];
  expired: Scalars['Boolean'];
  id: Scalars['PositiveInt'];
  legacyRawResult: Scalars['JSON'];
  metamoduleSubResults: Array<MetamoduleSubResult>;
  nextSurveyModule?: Maybe<NextSurveyModule>;
  recommendations: Array<RecommendationsForGoal>;
  strengths?: Maybe<StrengthSection>;
  summary?: Maybe<FeedbackSummary>;
  timestamp: Scalars['DateTime'];
  userUuid: Scalars['String'];
  virtaScore?: Maybe<Scalars['PositiveInt']>;
};


export type EndUserSurveyResultRecommendationsArgs = {
  language: Language;
};


export type EndUserSurveyResultStrengthsArgs = {
  language: Language;
};


export type EndUserSurveyResultSummaryArgs = {
  language: Language;
};

export type FeedbackGuide = {
  __typename?: 'FeedbackGuide';
  id: Scalars['ID'];
  sections: Array<DocumentSection>;
  title?: Maybe<Scalars['String']>;
};

export type FeedbackSummary = {
  __typename?: 'FeedbackSummary';
  content: Scalars['JSON'];
};

export enum FeedbackSummaryId {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type FeedbacksResult = {
  __typename?: 'FeedbacksResult';
  recommendations: Array<RecommendationsForGoal>;
  strengths?: Maybe<StrengthSection>;
  summary?: Maybe<FeedbackSummary>;
};

export enum Gender {
  Female = 'female',
  Male = 'male',
  Other = 'other',
  PreferNotToSay = 'prefer_not_to_say'
}

export type Group = {
  __typename?: 'Group';
  assessmentOrders?: Maybe<Array<AssessmentOrder>>;
  company: Scalars['String'];
  createdTimestamp: Scalars['DateTime'];
  department?: Maybe<Scalars['String']>;
  emailFilter?: Maybe<Scalars['String']>;
  endTimestamp: Scalars['DateTime'];
  id: Scalars['String'];
  joinLinks: Array<JoinLink>;
  results?: Maybe<BasicResultsResult>;
  startTimestamp: Scalars['DateTime'];
  userCount: Scalars['Int'];
  users?: Maybe<UserResult>;
};


export type GroupResultsArgs = {
  filter?: InputMaybe<ResultFilterInput>;
  language: AdminLanguage;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type GroupUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type GroupResult = {
  __typename?: 'GroupResult';
  data: Array<Group>;
  meta: ResultMeta;
};

export type GroupRoleInput = {
  resourceId: Scalars['String'];
  roles: Array<Scalars['String']>;
};

export type GroupRoles = {
  __typename?: 'GroupRoles';
  resource: Group;
  resourceId: Scalars['String'];
  roles: Array<Scalars['String']>;
};

export type JoinLink = {
  __typename?: 'JoinLink';
  locale: Language;
  url: Scalars['String'];
};

export enum Language {
  En = 'en',
  Fi = 'fi',
  Sv = 'sv'
}

export type MessageRecipient = Group | User;

export type MetamoduleSubResult = {
  __typename?: 'MetamoduleSubResult';
  moduleSubResults: Array<ModuleSubResult>;
  surveyMetamoduleKey: SurveyMetamoduleKey;
  surveyMetamoduleVersion: Scalars['Int'];
  surveyMetamoduleVid: Scalars['String'];
};

export type ModuleSubResult = {
  __typename?: 'ModuleSubResult';
  numericScore?: Maybe<Scalars['Int']>;
  surveyMetamoduleVid: Scalars['String'];
  surveyModuleKey: SurveyModuleKey;
  surveyModuleVersion: Scalars['Int'];
  surveyModuleVid: Scalars['String'];
};

export type MsAdUser = {
  __typename?: 'MsAdUser';
  displayName: Scalars['String'];
  id: Scalars['String'];
  userPrincipalName: Scalars['String'];
};

export type MsAdUsersResult = {
  __typename?: 'MsAdUsersResult';
  data: Array<MsAdUser>;
  itemCountLimit: Scalars['NonNegativeInt'];
};

export type MultiAuthorizationRequest = {
  action: Scalars['String'];
  queryId: Scalars['String'];
  resource?: InputMaybe<OsoResource>;
  resourceType: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAdminUsersToAdminGroup: Array<AdminUser>;
  addUsersToGroup: UpdateGroupUsersResult;
  createAdminGroup: AdminGroup;
  createAdminUserFromMsAdUser: AdminUser;
  createAssessmentOrder: AssessmentOrder;
  createGroup: Group;
  createScheduledMessage: ScheduledMessage;
  deleteAdminGroup: DeleteAdminGroupResult;
  deleteAdminUser: DeleteAdminUserResult;
  deleteScheduledMessages: DeleteScheduledMessagesResponse;
  deleteUser: DeleteUserResult;
  grantResourceRolesToAdminGroup: AdminGroupResourceRolesMutationResult;
  removeAdminUsersFromAdminGroup: RemoveAdminUsersFromAdminGroupResult;
  removeUsersFromGroup: UpdateGroupUsersResult;
  revokeResourceRolesOfAdminGroup: AdminGroupResourceRolesMutationResult;
  sendInvitationEmail: SendInvitationEmailResult;
  updateAdminGroup: AdminGroup;
  updateAssessmentOrder: AssessmentOrder;
  updateGroup: Group;
  updateUser: User;
  upsertUsers: Array<User>;
};


export type MutationAddAdminUsersToAdminGroupArgs = {
  input: AdminGroupAdminUserMutationInput;
};


export type MutationAddUsersToGroupArgs = {
  input: UpdateGroupUsersInput;
};


export type MutationCreateAdminGroupArgs = {
  input: CreateAdminGroupInput;
};


export type MutationCreateAdminUserFromMsAdUserArgs = {
  msAdUserId: Scalars['String'];
};


export type MutationCreateAssessmentOrderArgs = {
  input: CreateAssessmentOrderInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateScheduledMessageArgs = {
  input: ScheduledMessageInput;
};


export type MutationDeleteAdminGroupArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAdminUserArgs = {
  id: Scalars['String'];
};


export type MutationDeleteScheduledMessagesArgs = {
  input: DeleteScheduledMessagesInput;
};


export type MutationDeleteUserArgs = {
  userUuid: Scalars['String'];
};


export type MutationGrantResourceRolesToAdminGroupArgs = {
  input: AdminGroupResourceRolesMutationInput;
};


export type MutationRemoveAdminUsersFromAdminGroupArgs = {
  input: AdminGroupAdminUserMutationInput;
};


export type MutationRemoveUsersFromGroupArgs = {
  input: UpdateGroupUsersInput;
};


export type MutationRevokeResourceRolesOfAdminGroupArgs = {
  input: AdminGroupResourceRolesMutationInput;
};


export type MutationSendInvitationEmailArgs = {
  userUuid: Scalars['String'];
};


export type MutationUpdateAdminGroupArgs = {
  id: Scalars['String'];
  input: UpdateAdminGroupInput;
};


export type MutationUpdateAssessmentOrderArgs = {
  id: Scalars['String'];
  input: UpdateAssessmentOrderInput;
};


export type MutationUpdateGroupArgs = {
  id: Scalars['String'];
  input: UpdateGroupInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpsertUsersArgs = {
  input: UpsertUsersInput;
};

export type NextSurveyModule = {
  __typename?: 'NextSurveyModule';
  surveyMetamoduleVid: Scalars['String'];
  surveyModuleVid: Scalars['String'];
};

export type OsoResource = {
  osoAdminGroupId?: InputMaybe<Scalars['String']>;
  osoAdminUserId?: InputMaybe<Scalars['String']>;
  osoAssessmentOrderId?: InputMaybe<Scalars['String']>;
  osoCompanyGroupId?: InputMaybe<Scalars['String']>;
  osoUserId?: InputMaybe<Scalars['PositiveInt']>;
};

export type PaginationInput = {
  pageIndex: Scalars['NonNegativeInt'];
  pageSize: Scalars['PositiveInt'];
};

export type Query = {
  __typename?: 'Query';
  adminGroup: AdminGroup;
  adminGroups: AdminGroupsResult;
  adminUser: AdminUser;
  adminUsers: AdminUsersResult;
  assessmentOrder?: Maybe<AssessmentOrder>;
  assessmentOrders: AssessmentOrdersResult;
  authorize: Scalars['Boolean'];
  authorizeMulti: Array<Authorization>;
  authorizeResourceTypes: Array<Authorization>;
  authorizeSuperadmin: Scalars['Boolean'];
  availableResourceRoles: AvailableResourceRoles;
  dummy: Scalars['String'];
  endUserAssessmentOrder?: Maybe<EndUserAssessmentOrder>;
  group?: Maybe<Group>;
  groups: GroupResult;
  me: AdminUser;
  surveyMetaModules: Array<SurveyMetaModule>;
  surveyQuestions: Array<SurveyQuestion>;
  unlinkedMsAdUsersInAdAdminGroup: Array<MsAdUser>;
  user?: Maybe<User>;
  users: UserResult;
};


export type QueryAdminGroupArgs = {
  id: Scalars['String'];
};


export type QueryAdminGroupsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryAdminUserArgs = {
  id: Scalars['String'];
};


export type QueryAdminUsersArgs = {
  excludeMembersOfAdminGroup?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryAssessmentOrderArgs = {
  id: Scalars['String'];
};


export type QueryAssessmentOrdersArgs = {
  filter?: InputMaybe<AssessmentOrderFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryAuthorizeArgs = {
  input: AuthorizationRequest;
};


export type QueryAuthorizeMultiArgs = {
  input: Array<MultiAuthorizationRequest>;
};


export type QueryAuthorizeResourceTypesArgs = {
  input: Array<AuthorizeResourceTypeRequest>;
};


export type QueryEndUserAssessmentOrderArgs = {
  assessmentOrderId: Scalars['String'];
  language: Language;
  userUuid: Scalars['String'];
};


export type QueryGroupArgs = {
  id: Scalars['String'];
};


export type QueryGroupsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QuerySurveyQuestionsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryUserArgs = {
  uuid: Scalars['String'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  answerLabel?: Maybe<Scalars['String']>;
  answerValue?: Maybe<Scalars['StringOrInt']>;
  questionId: Scalars['PositiveInt'];
  questionLabel: Scalars['String'];
  sortKeys?: Maybe<Array<Maybe<Scalars['PositiveInt']>>>;
  surveyMetamoduleVid: Scalars['String'];
  surveyModuleVid: Scalars['String'];
};

export enum QuestionType {
  Binary = 'binary',
  OpenEnded = 'openEnded',
  Quaternary = 'quaternary',
  Slider = 'slider',
  Trinary = 'trinary'
}

export type RecommendationFeedback = {
  __typename?: 'RecommendationFeedback';
  content: Scalars['JSON'];
  feedbackGuide?: Maybe<FeedbackGuide>;
  header: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  tag: Scalars['String'];
  type: RecommendationType;
};

export enum RecommendationGoal {
  Fitness = 'fitness',
  MentalWellbeing = 'mentalWellbeing',
  MetabolicHealth = 'metabolicHealth',
  WeightManagement = 'weightManagement',
  Wellbeing = 'wellbeing'
}

export enum RecommendationType {
  Lifestyle = 'Lifestyle',
  Mindset = 'Mindset',
  Resource = 'Resource'
}

export type RecommendationsForGoal = {
  __typename?: 'RecommendationsForGoal';
  goal: RecommendationGoal;
  intro: Scalars['JSON'];
  recommendationsForGoal: Array<RecommendationFeedback>;
  title: Scalars['String'];
};

export type RemoveAdminUsersFromAdminGroupResult = {
  __typename?: 'RemoveAdminUsersFromAdminGroupResult';
  removedAdminUserIds: Array<Scalars['String']>;
};

export type ResourceRoleInput = {
  companyGroups?: InputMaybe<Array<GroupRoleInput>>;
};

export type ResourceRoles = {
  __typename?: 'ResourceRoles';
  companyGroups: Array<GroupRoles>;
};

export type ResultFilterInput = {
  groupId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  userUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type ResultMeta = {
  __typename?: 'ResultMeta';
  totalResultCount: Scalars['NonNegativeInt'];
};

export enum RiskId {
  Anxiety = 'anxiety',
  Burnout = 'burnout',
  Depression = 'depression',
  OrganicDustExposure = 'organicDustExposure',
  PreBurnout = 'preBurnout',
  RecentChronicCondition = 'recentChronicCondition',
  ShiftWorkSleepDisorder = 'shiftWorkSleepDisorder',
  SolventExposure = 'solventExposure',
  WorkAbility = 'workAbility'
}

export enum RiskLevel {
  High = 'high',
  None = 'none',
  NotCalculated = 'notCalculated'
}

export type RiskResult = {
  __typename?: 'RiskResult';
  key: RiskId;
  questions?: Maybe<Array<QuestionAnswer>>;
  value: RiskLevel;
};

export type ScheduledMessage = {
  __typename?: 'ScheduledMessage';
  fired: Scalars['Boolean'];
  id?: Maybe<Scalars['PositiveInt']>;
  languages: Array<Language>;
  recipients: Array<MessageRecipient>;
  sendAfter: Scalars['DateTime'];
  type: ScheduledMessageType;
};

export type ScheduledMessageInput = {
  assessmentOrderId?: InputMaybe<Scalars['String']>;
  languages: Array<Language>;
  recipients: ScheduledMessageRecipientsInput;
  sendAfter?: InputMaybe<Scalars['DateTime']>;
  type: ScheduledMessageType;
};

export type ScheduledMessageRecipients = {
  __typename?: 'ScheduledMessageRecipients';
  groups: Array<Group>;
  users: Array<User>;
};

export type ScheduledMessageRecipientsInput = {
  groupIds: Array<Scalars['String']>;
  userUuids: Array<Scalars['String']>;
};

export enum ScheduledMessageType {
  EmailInvitation = 'EMAIL_INVITATION',
  EmailReminder = 'EMAIL_REMINDER'
}

export enum SectorKey {
  Exercise = 'exercise',
  Finance = 'finance',
  MeaningfulLife = 'meaningfulLife',
  MentalHealth = 'mentalHealth',
  Nutrition = 'nutrition',
  PhysicalHealth = 'physicalHealth',
  Relationships = 'relationships',
  Sleep = 'sleep',
  Work = 'work'
}

export type SectorResult = {
  __typename?: 'SectorResult';
  key: SectorKey;
  value?: Maybe<Scalars['PositiveInt']>;
};

export type SendInvitationEmailResult = {
  __typename?: 'SendInvitationEmailResult';
  userUuid: Scalars['String'];
};

export enum Severity {
  Good = 'good',
  Major = 'major',
  Minor = 'minor',
  Neutral = 'neutral'
}

export type SortInput = {
  desc?: InputMaybe<Scalars['Boolean']>;
  sortBy: Scalars['String'];
};

export type StrengthFeedback = {
  __typename?: 'StrengthFeedback';
  content: Scalars['JSON'];
  header: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['ID'];
};

export type StrengthSection = {
  __typename?: 'StrengthSection';
  cards: Array<StrengthFeedback>;
  intro: Scalars['String'];
  title: Scalars['String'];
};

export enum SurveyFlowVariant {
  Default = 'default',
  OnlyPsychosocialWorkload = 'only_psychosocial_workload'
}

export type SurveyMetaModule = {
  __typename?: 'SurveyMetaModule';
  key: Scalars['String'];
  surveyModules: Array<SurveyModule>;
  vid: Scalars['String'];
};

export enum SurveyMetamoduleKey {
  Core = 'core',
  FeedbackOnWork = 'feedback_on_work',
  InspiringCulture = 'inspiring_culture',
  MotivationalWork = 'motivational_work',
  PsychosocialWorkload = 'psychosocial_workload',
  RiskOfIllness = 'risk_of_illness',
  WorkSafety = 'work_safety'
}

export type SurveyMetamoduleModulePair = {
  surveyMetamoduleVid: Scalars['String'];
  surveyModuleVid: Scalars['String'];
};

export type SurveyModule = {
  __typename?: 'SurveyModule';
  key: Scalars['String'];
  vid: Scalars['String'];
};

export enum SurveyModuleKey {
  AsthmaRisks = 'asthma_risks',
  CultureOfInteraction = 'culture_of_interaction',
  CultureOfManagement = 'culture_of_management',
  CultureOfMeaningfulness = 'culture_of_meaningfulness',
  Exercise = 'exercise',
  Finance = 'finance',
  GeneralWorkSafety = 'general_work_safety',
  MeaningfulLife = 'meaningful_life',
  MentalHealth = 'mental_health',
  Nutrition = 'nutrition',
  OpenFeedbackOnWork = 'open_feedback_on_work',
  PhysicalHealth = 'physical_health',
  PsychosocialWorkloadFactors = 'psychosocial_workload_factors',
  Relationships = 'relationships',
  Screening = 'screening',
  SelfManagementSkills = 'self_management_skills',
  Sleep = 'sleep',
  Solvents = 'solvents',
  Work = 'work',
  WorkAbilityManagement = 'work_ability_management',
  WorkPhysicalFactors = 'work_physical_factors',
  WorkPsychosocialFactors = 'work_psychosocial_factors',
  WorkingHours = 'working_hours'
}

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  explanationEn?: Maybe<Scalars['String']>;
  explanationFi?: Maybe<Scalars['String']>;
  explanationSv?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  questionType: QuestionType;
  scaleEn: Array<Scalars['String']>;
  scaleFi: Array<Scalars['String']>;
  scaleSv: Array<Scalars['String']>;
  surveyMetamoduleKey: Scalars['String'];
  surveyModuleKey: Scalars['String'];
  surveyModuleOrderNr: Scalars['Int'];
  titleEn: Scalars['String'];
  titleFi: Scalars['String'];
  titleSv: Scalars['String'];
};

export type UpdateAdminGroupInput = {
  name: Scalars['String'];
};

export type UpdateAssessmentOrderInput = {
  endTimestamp: Scalars['DateTime'];
  groupIds: Array<Scalars['String']>;
  name: Scalars['String'];
  startTimestamp: Scalars['DateTime'];
};

export type UpdateGroupInput = {
  company: Scalars['String'];
  department?: InputMaybe<Scalars['String']>;
  emailFilter?: InputMaybe<Scalars['String']>;
  endTimestamp: Scalars['DateTime'];
  startTimestamp: Scalars['DateTime'];
};

export type UpdateGroupUsersInput = {
  groupId: Scalars['String'];
  userUuids: Array<Scalars['String']>;
};

export type UpdateGroupUsersResult = {
  __typename?: 'UpdateGroupUsersResult';
  groupId: Scalars['String'];
  userUuids: Array<Scalars['String']>;
};

export type UpdateUserInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  groupIds: Array<Scalars['String']>;
  language: Language;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  trialExpireAt?: InputMaybe<Scalars['Date']>;
  uuid: Scalars['String'];
};

export type UpsertUserInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  language: Language;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpsertUsersInput = {
  groupIds: Array<Scalars['String']>;
  users: Array<UpsertUserInput>;
};

export type User = {
  __typename?: 'User';
  assessmentOrders?: Maybe<Array<UserAssessmentOrder>>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['PositiveInt'];
  language?: Maybe<Language>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  results?: Maybe<DetailedResultsResult>;
  trialExpireAt?: Maybe<Scalars['Date']>;
  uuid: Scalars['String'];
};


export type UserResultsArgs = {
  filter?: InputMaybe<ResultFilterInput>;
  language: AdminLanguage;
  sort?: InputMaybe<Array<SortInput>>;
};

export type UserAssessmentOrder = {
  __typename?: 'UserAssessmentOrder';
  id: Scalars['String'];
  surveyCompleted: Scalars['Boolean'];
};

export type UserFilterInput = {
  assessmentOrderId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  withIncompleteSurvey?: InputMaybe<Scalars['Boolean']>;
};

export type UserResult = {
  __typename?: 'UserResult';
  data: Array<User>;
  meta: ResultMeta;
};

export type BasicResultFieldsFragment = { __typename?: 'BasicResults', id: number, assessmentOrderId: string, email: string, fullName?: string | null, timestamp: string, userUuid: string, virtaScore?: number | null, workAbilityChallenge: string, riskResults: Array<{ __typename?: 'RiskResult', key: RiskId, value: RiskLevel }>, sectorResults: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, strengthSectors: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, challengeSectors: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, cluster?: { __typename?: 'Cluster', key: string, severity: Severity } | null };

export type BasicUserFieldsFragment = { __typename?: 'User', id: number, uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null };

export type DetailedResultFieldsFragment = { __typename?: 'DetailedResults', id: number, assessmentOrderId: string, email: string, fullName?: string | null, timestamp: string, userUuid: string, virtaScore?: number | null, workAbilityChallenge: string, questionAnswers: Array<{ __typename?: 'QuestionAnswer', answerValue?: any | null, answerLabel?: string | null, questionLabel: string, questionId: number, surveyMetamoduleVid: string, surveyModuleVid: string, sortKeys?: Array<number | null> | null }>, riskResults: Array<{ __typename?: 'RiskResult', key: RiskId, value: RiskLevel, questions?: Array<{ __typename?: 'QuestionAnswer', answerValue?: any | null, answerLabel?: string | null, questionLabel: string, questionId: number, surveyMetamoduleVid: string, surveyModuleVid: string }> | null }>, sectorResults: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, strengthSectors: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, challengeSectors: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, cluster?: { __typename?: 'Cluster', key: string, severity: Severity } | null, surveyModules: Array<{ __typename?: 'SurveyModule', vid: string, key: string }> };

export type FullUserFieldsFragment = { __typename?: 'User', id: number, uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, dateOfBirth?: string | null, gender?: Gender | null, phoneNumber?: string | null, trialExpireAt?: string | null, language?: Language | null };

export type GroupFieldsFragment = { __typename?: 'Group', company: string, createdTimestamp: string, department?: string | null, emailFilter?: string | null, endTimestamp: string, id: string, startTimestamp: string, userCount: number, joinLinks: Array<{ __typename?: 'JoinLink', locale: Language, url: string }> };

export type SurveyQuestionFieldsFragment = { __typename?: 'SurveyQuestion', id: number, titleFi: string, titleEn: string, explanationFi?: string | null, explanationEn?: string | null, scaleFi: Array<string>, scaleEn: Array<string>, questionType: QuestionType, surveyModuleKey: string, surveyModuleOrderNr: number, surveyMetamoduleKey: string };

export type AddAdminUsersToAdminGroupMutationVariables = Exact<{
  input: AdminGroupAdminUserMutationInput;
}>;


export type AddAdminUsersToAdminGroupMutation = { __typename?: 'Mutation', addAdminUsersToAdminGroup: Array<{ __typename?: 'AdminUser', id: string }> };

export type AddUsersToGroupMutationVariables = Exact<{
  input: UpdateGroupUsersInput;
}>;


export type AddUsersToGroupMutation = { __typename?: 'Mutation', addUsersToGroup: { __typename?: 'UpdateGroupUsersResult', groupId: string, userUuids: Array<string> } };

export type CreateAdminGroupMutationVariables = Exact<{
  input: CreateAdminGroupInput;
}>;


export type CreateAdminGroupMutation = { __typename?: 'Mutation', createAdminGroup: { __typename?: 'AdminGroup', id: string } };

export type CreateAdminUserFromMsAdUserMutationVariables = Exact<{
  msAdUserId: Scalars['String'];
}>;


export type CreateAdminUserFromMsAdUserMutation = { __typename?: 'Mutation', createAdminUserFromMsAdUser: { __typename?: 'AdminUser', id: string } };

export type CreateAssessmentOrderMutationVariables = Exact<{
  input: CreateAssessmentOrderInput;
}>;


export type CreateAssessmentOrderMutation = { __typename?: 'Mutation', createAssessmentOrder: { __typename?: 'AssessmentOrder', id: string, name: string, startTimestamp: string, endTimestamp?: string | null } };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string, company: string, department?: string | null, emailFilter?: string | null, startTimestamp: string, endTimestamp: string } };

export type CreateScheduledMessageMutationVariables = Exact<{
  input: ScheduledMessageInput;
}>;


export type CreateScheduledMessageMutation = { __typename?: 'Mutation', createScheduledMessage: { __typename?: 'ScheduledMessage', id?: number | null, sendAfter: string, fired: boolean, type: ScheduledMessageType, languages: Array<Language>, recipients: Array<{ __typename?: 'Group', company: string, id: string } | { __typename?: 'User', fullName?: string | null, uuid: string }> } };

export type DeleteAdminUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAdminUserMutation = { __typename?: 'Mutation', deleteAdminUser: { __typename?: 'DeleteAdminUserResult', id: string } };

export type DeleteScheduledMessagesMutationVariables = Exact<{
  input: DeleteScheduledMessagesInput;
}>;


export type DeleteScheduledMessagesMutation = { __typename?: 'Mutation', deleteScheduledMessages: { __typename?: 'DeleteScheduledMessagesResponse', ids: Array<number> } };

export type DeleteUserMutationVariables = Exact<{
  userUuid: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'DeleteUserResult', userUuid: string } };

export type GetAdminGroupQueryVariables = Exact<{
  id: Scalars['String'];
  includeMembers: Scalars['Boolean'];
  includeResourceRoles: Scalars['Boolean'];
}>;


export type GetAdminGroupQuery = { __typename?: 'Query', adminGroup: { __typename?: 'AdminGroup', id: string, name: string, createdAt: string, updatedAt: string, memberCount?: number | null, members?: Array<{ __typename?: 'AdminUser', externalRealName: string, externalHumanReadableUsername: string, id: string, adminAuthenticationProviderId: string, externalId: string }>, resourceRoles?: { __typename?: 'ResourceRoles', companyGroups: Array<{ __typename?: 'GroupRoles', roles: Array<string>, resource: { __typename?: 'Group', id: string, company: string, department?: string | null } }> } | null } };

export type GetAdminGroupGroupRoleDataQueryVariables = Exact<{
  adminGroupId: Scalars['String'];
  groupId: Scalars['String'];
}>;


export type GetAdminGroupGroupRoleDataQuery = { __typename?: 'Query', adminGroup: { __typename?: 'AdminGroup', id: string, name: string, resourceRoles?: { __typename?: 'ResourceRoles', companyGroups: Array<{ __typename?: 'GroupRoles', resourceId: string, roles: Array<string> }> } | null }, group?: { __typename?: 'Group', company: string, department?: string | null, id: string } | null, availableResourceRoles: { __typename?: 'AvailableResourceRoles', companyGroups: Array<string> } };

export type GetAdminGroupsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type GetAdminGroupsQuery = { __typename?: 'Query', adminGroups: { __typename?: 'AdminGroupsResult', data: Array<{ __typename?: 'AdminGroup', id: string, name: string, memberCount?: number | null, createdAt: string, updatedAt: string }>, meta: { __typename?: 'ResultMeta', totalResultCount: number } } };

export type GetAdminUserQueryVariables = Exact<{
  id: Scalars['String'];
  includeGlobalRoles: Scalars['Boolean'];
  includeAdminGroups: Scalars['Boolean'];
}>;


export type GetAdminUserQuery = { __typename?: 'Query', adminUser: { __typename?: 'AdminUser', id: string, externalRealName: string, externalHumanReadableUsername: string, adminAuthenticationProviderId: string, externalOrganizationId: string, externalId: string, createdAt: string, lastAuthenticatedAt?: string | null, globalRoles?: Array<string>, isSuperadmin: boolean, adminGroups?: { __typename?: 'AdminGroupsResult', data: Array<{ __typename?: 'AdminGroup', id: string, name: string }> } } };

export type GetAdminUserEmailsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetAdminUserEmailsQuery = { __typename?: 'Query', adminUsers: { __typename?: 'AdminUsersResult', data: Array<{ __typename?: 'AdminUser', externalHumanReadableUsername: string }> } };

export type GetAdminUsersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<Scalars['String']>;
  excludeMembersOfAdminGroup?: InputMaybe<Scalars['String']>;
  includeGlobalRoles: Scalars['Boolean'];
  includeAdminGroups: Scalars['Boolean'];
}>;


export type GetAdminUsersQuery = { __typename?: 'Query', adminUsers: { __typename?: 'AdminUsersResult', data: Array<{ __typename?: 'AdminUser', id: string, externalRealName: string, externalHumanReadableUsername: string, adminAuthenticationProviderId: string, externalOrganizationId: string, createdAt: string, lastAuthenticatedAt?: string | null, globalRoles?: Array<string>, isSuperadmin: boolean, adminGroups?: { __typename?: 'AdminGroupsResult', data: Array<{ __typename?: 'AdminGroup', id: string, name: string }> } }>, meta: { __typename?: 'ResultMeta', totalResultCount: number } } };

export type GetAssessmentOrderQueryVariables = Exact<{
  id: Scalars['String'];
  usersPagination?: InputMaybe<PaginationInput>;
  usersSort?: InputMaybe<Array<SortInput> | SortInput>;
  usersFilter?: InputMaybe<UserFilterInput>;
}>;


export type GetAssessmentOrderQuery = { __typename?: 'Query', assessmentOrder?: { __typename?: 'AssessmentOrder', id: string, name: string, startTimestamp: string, endTimestamp?: string | null, surveyMetaModules: Array<{ __typename?: 'SurveyMetaModule', vid: string, key: string, surveyModules: Array<{ __typename?: 'SurveyModule', vid: string, key: string }> }>, groups: Array<{ __typename?: 'Group', company: string, createdTimestamp: string, department?: string | null, emailFilter?: string | null, endTimestamp: string, id: string, startTimestamp: string, userCount: number, assessmentOrders?: Array<{ __typename?: 'AssessmentOrder', id: string, surveyCompletedCount: number }> | null, joinLinks: Array<{ __typename?: 'JoinLink', locale: Language, url: string }> }>, messages: Array<{ __typename?: 'ScheduledMessage', id?: number | null, sendAfter: string, fired: boolean, type: ScheduledMessageType, languages: Array<Language>, recipients: Array<{ __typename?: 'Group', company: string, createdTimestamp: string, department?: string | null, emailFilter?: string | null, endTimestamp: string, id: string, startTimestamp: string, userCount: number, joinLinks: Array<{ __typename?: 'JoinLink', locale: Language, url: string }> } | { __typename?: 'User', uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null }> }>, users: { __typename?: 'UserResult', data: Array<{ __typename?: 'User', id: number, uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null }>, meta: { __typename?: 'ResultMeta', totalResultCount: number } } } | null };

export type GetAssessmentOrdersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<AssessmentOrderFilterInput>;
}>;


export type GetAssessmentOrdersQuery = { __typename?: 'Query', assessmentOrders: { __typename?: 'AssessmentOrdersResult', data: Array<{ __typename?: 'AssessmentOrder', id: string, name: string, startTimestamp: string, endTimestamp?: string | null, groups: Array<{ __typename?: 'Group', id: string, company: string }> }>, meta: { __typename?: 'ResultMeta', totalResultCount: number } } };

export type GetAuthorizationQueryVariables = Exact<{
  input: AuthorizationRequest;
}>;


export type GetAuthorizationQuery = { __typename?: 'Query', authorize: boolean };

export type GetAuthorizationForResourceTypesQueryVariables = Exact<{
  input: Array<AuthorizeResourceTypeRequest> | AuthorizeResourceTypeRequest;
}>;


export type GetAuthorizationForResourceTypesQuery = { __typename?: 'Query', authorizeResourceTypes: Array<{ __typename?: 'Authorization', queryId: string, authorized: boolean }> };

export type GetEndUserAssessmentOrderWithResultsQueryVariables = Exact<{
  userUuid: Scalars['String'];
  assessmentOrderId: Scalars['String'];
  resultId: Scalars['PositiveInt'];
  language: Language;
}>;


export type GetEndUserAssessmentOrderWithResultsQuery = { __typename?: 'Query', endUserAssessmentOrder?: { __typename?: 'EndUserAssessmentOrder', id: string, name: string, closed: boolean, personal: boolean, trial: boolean, progressPercentage: number, features: { __typename?: 'EndUserAssessmentOrderFeatures', showResultsToEndUser: boolean, surveyFlowVariant: SurveyFlowVariant }, result: { __typename?: 'EndUserSurveyResult', legacyRawResult: any, id: number, userUuid: string, timestamp: string, virtaScore?: number | null, expired: boolean, completed: boolean, summary?: { __typename?: 'FeedbackSummary', content: any } | null, strengths?: { __typename?: 'StrengthSection', title: string, intro: string, cards: Array<{ __typename?: 'StrengthFeedback', id: string, header: string, content: any, icon: string }> } | null, recommendations: Array<{ __typename?: 'RecommendationsForGoal', goal: RecommendationGoal, title: string, intro: any, recommendationsForGoal: Array<{ __typename?: 'RecommendationFeedback', id: string, header: string, content: any, icon: string, type: RecommendationType, tag: string, feedbackGuide?: { __typename?: 'FeedbackGuide', id: string, title?: string | null, sections: Array<{ __typename?: 'DocumentSection', id: string, content: { __typename?: 'DocumentSectionContent', value: any } }> } | null }> }> }, resultHistory: Array<{ __typename?: 'EndUserSurveyResult', legacyRawResult: any }> } | null, user?: { __typename?: 'User', uuid: string, email: string, fullName?: string | null } | null };

export type GetGroupQueryVariables = Exact<{
  id: Scalars['String'];
  includeAssessmentOrders: Scalars['Boolean'];
  includeResults: Scalars['Boolean'];
  includeUsers: Scalars['Boolean'];
  language: AdminLanguage;
  resultsPagination?: InputMaybe<PaginationInput>;
  resultsFilter?: InputMaybe<ResultFilterInput>;
  resultsSort?: InputMaybe<Array<SortInput> | SortInput>;
  usersPagination?: InputMaybe<PaginationInput>;
  usersFilter?: InputMaybe<UserFilterInput>;
  usersSort?: InputMaybe<Array<SortInput> | SortInput>;
  orderUsersPagination?: InputMaybe<PaginationInput>;
  orderUsersFilter?: InputMaybe<UserFilterInput>;
  orderUsersSort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetGroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', company: string, createdTimestamp: string, department?: string | null, emailFilter?: string | null, endTimestamp: string, id: string, startTimestamp: string, userCount: number, assessmentOrders?: Array<{ __typename?: 'AssessmentOrder', id: string, name: string, startTimestamp: string, endTimestamp?: string | null, surveyCompletedCount: number, users: { __typename?: 'UserResult', data: Array<{ __typename?: 'User', id: number, uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, assessmentOrders?: Array<{ __typename?: 'UserAssessmentOrder', id: string, surveyCompleted: boolean }> | null }>, meta: { __typename?: 'ResultMeta', totalResultCount: number } } }> | null, results?: { __typename?: 'BasicResultsResult', data?: Array<{ __typename?: 'BasicResults', id: number, assessmentOrderId: string, email: string, fullName?: string | null, timestamp: string, userUuid: string, virtaScore?: number | null, workAbilityChallenge: string, riskResults: Array<{ __typename?: 'RiskResult', key: RiskId, value: RiskLevel }>, sectorResults: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, strengthSectors: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, challengeSectors: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, cluster?: { __typename?: 'Cluster', key: string, severity: Severity } | null }> | null, meta: { __typename?: 'ResultMeta', totalResultCount: number } } | null, users?: { __typename?: 'UserResult', data: Array<{ __typename?: 'User', id: number, uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null }>, meta: { __typename?: 'ResultMeta', totalResultCount: number } } | null, joinLinks: Array<{ __typename?: 'JoinLink', locale: Language, url: string }> } | null };

export type GetGroupsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type GetGroupsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupResult', data: Array<{ __typename?: 'Group', company: string, createdTimestamp: string, department?: string | null, emailFilter?: string | null, endTimestamp: string, id: string, startTimestamp: string, userCount: number, joinLinks: Array<{ __typename?: 'JoinLink', locale: Language, url: string }> }>, meta: { __typename?: 'ResultMeta', totalResultCount: number } } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'AdminUser', globalRoles: Array<string> } };

export type GetMultiAuthorizationQueryVariables = Exact<{
  input: Array<MultiAuthorizationRequest> | MultiAuthorizationRequest;
}>;


export type GetMultiAuthorizationQuery = { __typename?: 'Query', authorizeMulti: Array<{ __typename?: 'Authorization', queryId: string, authorized: boolean }> };

export type GetSuperadminAuthorizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuperadminAuthorizationQuery = { __typename?: 'Query', authorizeSuperadmin: boolean };

export type GetSurveyMetaModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurveyMetaModulesQuery = { __typename?: 'Query', surveyMetaModules: Array<{ __typename?: 'SurveyMetaModule', vid: string, key: string, surveyModules: Array<{ __typename?: 'SurveyModule', vid: string, key: string }> }> };

export type GetSurveyQuestionsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type GetSurveyQuestionsQuery = { __typename?: 'Query', surveyQuestions: Array<{ __typename?: 'SurveyQuestion', id: number, titleFi: string, titleEn: string, explanationFi?: string | null, explanationEn?: string | null, scaleFi: Array<string>, scaleEn: Array<string>, questionType: QuestionType, surveyModuleKey: string, surveyModuleOrderNr: number, surveyMetamoduleKey: string }> };

export type GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnlinkedMsAdUsersInAdAdminGroupQuery = { __typename?: 'Query', unlinkedMsAdUsersInAdAdminGroup: Array<{ __typename?: 'MsAdUser', id: string, userPrincipalName: string, displayName: string }> };

export type GetUserQueryVariables = Exact<{
  uuid: Scalars['String'];
  includeGroups: Scalars['Boolean'];
  includeResults: Scalars['Boolean'];
  language: AdminLanguage;
  resultsFilter?: InputMaybe<ResultFilterInput>;
  resultsSort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, dateOfBirth?: string | null, gender?: Gender | null, phoneNumber?: string | null, trialExpireAt?: string | null, language?: Language | null, groups?: Array<{ __typename?: 'Group', id: string, company: string, department?: string | null }> | null, results?: { __typename?: 'DetailedResultsResult', data?: Array<{ __typename?: 'DetailedResults', id: number, assessmentOrderId: string, email: string, fullName?: string | null, timestamp: string, userUuid: string, virtaScore?: number | null, workAbilityChallenge: string, questionAnswers: Array<{ __typename?: 'QuestionAnswer', answerValue?: any | null, answerLabel?: string | null, questionLabel: string, questionId: number, surveyMetamoduleVid: string, surveyModuleVid: string, sortKeys?: Array<number | null> | null }>, riskResults: Array<{ __typename?: 'RiskResult', key: RiskId, value: RiskLevel, questions?: Array<{ __typename?: 'QuestionAnswer', answerValue?: any | null, answerLabel?: string | null, questionLabel: string, questionId: number, surveyMetamoduleVid: string, surveyModuleVid: string }> | null }>, sectorResults: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, strengthSectors: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, challengeSectors: Array<{ __typename?: 'SectorResult', key: SectorKey, value?: number | null }>, cluster?: { __typename?: 'Cluster', key: string, severity: Severity } | null, surveyModules: Array<{ __typename?: 'SurveyModule', vid: string, key: string }> }> | null, meta: { __typename?: 'ResultMeta', totalResultCount: number } } | null } | null };

export type GetUsersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserResult', data: Array<{ __typename?: 'User', id: number, uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null }>, meta: { __typename?: 'ResultMeta', totalResultCount: number } } };

export type GrantResourceRolesToAdminGroupMutationVariables = Exact<{
  input: AdminGroupResourceRolesMutationInput;
}>;


export type GrantResourceRolesToAdminGroupMutation = { __typename?: 'Mutation', grantResourceRolesToAdminGroup: { __typename?: 'AdminGroupResourceRolesMutationResult', adminGroupId: string } };

export type RemoveAdminUsersFromAdminGroupMutationVariables = Exact<{
  input: AdminGroupAdminUserMutationInput;
}>;


export type RemoveAdminUsersFromAdminGroupMutation = { __typename?: 'Mutation', removeAdminUsersFromAdminGroup: { __typename?: 'RemoveAdminUsersFromAdminGroupResult', removedAdminUserIds: Array<string> } };

export type RemoveUsersFromGroupMutationVariables = Exact<{
  input: UpdateGroupUsersInput;
}>;


export type RemoveUsersFromGroupMutation = { __typename?: 'Mutation', removeUsersFromGroup: { __typename?: 'UpdateGroupUsersResult', groupId: string, userUuids: Array<string> } };

export type RevokeResourceRolesOfAdminGroupMutationVariables = Exact<{
  input: AdminGroupResourceRolesMutationInput;
}>;


export type RevokeResourceRolesOfAdminGroupMutation = { __typename?: 'Mutation', revokeResourceRolesOfAdminGroup: { __typename?: 'AdminGroupResourceRolesMutationResult', adminGroupId: string } };

export type SendInvitationEmailMutationVariables = Exact<{
  userUuid: Scalars['String'];
}>;


export type SendInvitationEmailMutation = { __typename?: 'Mutation', sendInvitationEmail: { __typename?: 'SendInvitationEmailResult', userUuid: string } };

export type UpdateAdminGroupMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateAdminGroupInput;
}>;


export type UpdateAdminGroupMutation = { __typename?: 'Mutation', updateAdminGroup: { __typename?: 'AdminGroup', name: string } };

export type UpdateAssessmentOrderMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateAssessmentOrderInput;
}>;


export type UpdateAssessmentOrderMutation = { __typename?: 'Mutation', updateAssessmentOrder: { __typename?: 'AssessmentOrder', id: string, name: string, startTimestamp: string, endTimestamp?: string | null } };

export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'Group', id: string, company: string, department?: string | null, emailFilter?: string | null, startTimestamp: string, endTimestamp: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', uuid: string, firstName?: string | null, lastName?: string | null, email: string, dateOfBirth?: string | null, gender?: Gender | null, phoneNumber?: string | null, language?: Language | null, trialExpireAt?: string | null, groups?: Array<{ __typename?: 'Group', id: string, company: string, department?: string | null }> | null } };

export type UpsertUsersMutationVariables = Exact<{
  input: UpsertUsersInput;
}>;


export type UpsertUsersMutation = { __typename?: 'Mutation', upsertUsers: Array<{ __typename?: 'User', email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, uuid: string }> };

export const BasicResultFieldsFragmentDoc = gql`
    fragment BasicResultFields on BasicResults {
  id
  assessmentOrderId
  email
  fullName
  riskResults {
    key
    value
  }
  sectorResults {
    key
    value
  }
  strengthSectors {
    key
    value
  }
  challengeSectors {
    key
    value
  }
  timestamp
  userUuid
  virtaScore
  cluster {
    key
    severity
  }
  workAbilityChallenge
}
    `;
export const BasicUserFieldsFragmentDoc = gql`
    fragment BasicUserFields on User {
  id
  uuid
  email
  firstName
  lastName
  fullName
}
    `;
export const DetailedResultFieldsFragmentDoc = gql`
    fragment DetailedResultFields on DetailedResults {
  id
  assessmentOrderId
  email
  fullName
  questionAnswers {
    answerValue
    answerLabel
    questionLabel
    questionId
    surveyMetamoduleVid
    surveyModuleVid
    sortKeys
  }
  riskResults {
    key
    value
    questions {
      answerValue
      answerLabel
      questionLabel
      questionId
      surveyMetamoduleVid
      surveyModuleVid
    }
  }
  sectorResults {
    key
    value
  }
  strengthSectors {
    key
    value
  }
  challengeSectors {
    key
    value
  }
  timestamp
  userUuid
  virtaScore
  cluster {
    key
    severity
  }
  workAbilityChallenge
  surveyModules {
    vid
    key
  }
}
    `;
export const FullUserFieldsFragmentDoc = gql`
    fragment FullUserFields on User {
  id
  uuid
  email
  firstName
  lastName
  fullName
  dateOfBirth
  gender
  phoneNumber
  trialExpireAt
  language
}
    `;
export const GroupFieldsFragmentDoc = gql`
    fragment GroupFields on Group {
  company
  createdTimestamp
  department
  emailFilter
  endTimestamp
  joinLinks {
    locale
    url
  }
  id
  startTimestamp
  userCount
}
    `;
export const SurveyQuestionFieldsFragmentDoc = gql`
    fragment SurveyQuestionFields on SurveyQuestion {
  id
  titleFi
  titleEn
  explanationFi
  explanationEn
  scaleFi
  scaleEn
  questionType
  surveyModuleKey
  surveyModuleOrderNr
  surveyMetamoduleKey
}
    `;
export const AddAdminUsersToAdminGroupDocument = gql`
    mutation AddAdminUsersToAdminGroup($input: AdminGroupAdminUserMutationInput!) {
  addAdminUsersToAdminGroup(input: $input) {
    id
  }
}
    `;
export type AddAdminUsersToAdminGroupMutationFn = Apollo.MutationFunction<AddAdminUsersToAdminGroupMutation, AddAdminUsersToAdminGroupMutationVariables>;

/**
 * __useAddAdminUsersToAdminGroupMutation__
 *
 * To run a mutation, you first call `useAddAdminUsersToAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdminUsersToAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdminUsersToAdminGroupMutation, { data, loading, error }] = useAddAdminUsersToAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAdminUsersToAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddAdminUsersToAdminGroupMutation, AddAdminUsersToAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAdminUsersToAdminGroupMutation, AddAdminUsersToAdminGroupMutationVariables>(AddAdminUsersToAdminGroupDocument, options);
      }
export type AddAdminUsersToAdminGroupMutationHookResult = ReturnType<typeof useAddAdminUsersToAdminGroupMutation>;
export type AddAdminUsersToAdminGroupMutationResult = Apollo.MutationResult<AddAdminUsersToAdminGroupMutation>;
export type AddAdminUsersToAdminGroupMutationOptions = Apollo.BaseMutationOptions<AddAdminUsersToAdminGroupMutation, AddAdminUsersToAdminGroupMutationVariables>;
export const AddUsersToGroupDocument = gql`
    mutation AddUsersToGroup($input: UpdateGroupUsersInput!) {
  addUsersToGroup(input: $input) {
    groupId
    userUuids
  }
}
    `;
export type AddUsersToGroupMutationFn = Apollo.MutationFunction<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>;

/**
 * __useAddUsersToGroupMutation__
 *
 * To run a mutation, you first call `useAddUsersToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToGroupMutation, { data, loading, error }] = useAddUsersToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUsersToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>(AddUsersToGroupDocument, options);
      }
export type AddUsersToGroupMutationHookResult = ReturnType<typeof useAddUsersToGroupMutation>;
export type AddUsersToGroupMutationResult = Apollo.MutationResult<AddUsersToGroupMutation>;
export type AddUsersToGroupMutationOptions = Apollo.BaseMutationOptions<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>;
export const CreateAdminGroupDocument = gql`
    mutation CreateAdminGroup($input: CreateAdminGroupInput!) {
  createAdminGroup(input: $input) {
    id
  }
}
    `;
export type CreateAdminGroupMutationFn = Apollo.MutationFunction<CreateAdminGroupMutation, CreateAdminGroupMutationVariables>;

/**
 * __useCreateAdminGroupMutation__
 *
 * To run a mutation, you first call `useCreateAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminGroupMutation, { data, loading, error }] = useCreateAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminGroupMutation, CreateAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminGroupMutation, CreateAdminGroupMutationVariables>(CreateAdminGroupDocument, options);
      }
export type CreateAdminGroupMutationHookResult = ReturnType<typeof useCreateAdminGroupMutation>;
export type CreateAdminGroupMutationResult = Apollo.MutationResult<CreateAdminGroupMutation>;
export type CreateAdminGroupMutationOptions = Apollo.BaseMutationOptions<CreateAdminGroupMutation, CreateAdminGroupMutationVariables>;
export const CreateAdminUserFromMsAdUserDocument = gql`
    mutation CreateAdminUserFromMsAdUser($msAdUserId: String!) {
  createAdminUserFromMsAdUser(msAdUserId: $msAdUserId) {
    id
  }
}
    `;
export type CreateAdminUserFromMsAdUserMutationFn = Apollo.MutationFunction<CreateAdminUserFromMsAdUserMutation, CreateAdminUserFromMsAdUserMutationVariables>;

/**
 * __useCreateAdminUserFromMsAdUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserFromMsAdUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserFromMsAdUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserFromMsAdUserMutation, { data, loading, error }] = useCreateAdminUserFromMsAdUserMutation({
 *   variables: {
 *      msAdUserId: // value for 'msAdUserId'
 *   },
 * });
 */
export function useCreateAdminUserFromMsAdUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminUserFromMsAdUserMutation, CreateAdminUserFromMsAdUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminUserFromMsAdUserMutation, CreateAdminUserFromMsAdUserMutationVariables>(CreateAdminUserFromMsAdUserDocument, options);
      }
export type CreateAdminUserFromMsAdUserMutationHookResult = ReturnType<typeof useCreateAdminUserFromMsAdUserMutation>;
export type CreateAdminUserFromMsAdUserMutationResult = Apollo.MutationResult<CreateAdminUserFromMsAdUserMutation>;
export type CreateAdminUserFromMsAdUserMutationOptions = Apollo.BaseMutationOptions<CreateAdminUserFromMsAdUserMutation, CreateAdminUserFromMsAdUserMutationVariables>;
export const CreateAssessmentOrderDocument = gql`
    mutation CreateAssessmentOrder($input: CreateAssessmentOrderInput!) {
  createAssessmentOrder(input: $input) {
    id
    name
    startTimestamp
    endTimestamp
  }
}
    `;
export type CreateAssessmentOrderMutationFn = Apollo.MutationFunction<CreateAssessmentOrderMutation, CreateAssessmentOrderMutationVariables>;

/**
 * __useCreateAssessmentOrderMutation__
 *
 * To run a mutation, you first call `useCreateAssessmentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssessmentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssessmentOrderMutation, { data, loading, error }] = useCreateAssessmentOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssessmentOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssessmentOrderMutation, CreateAssessmentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssessmentOrderMutation, CreateAssessmentOrderMutationVariables>(CreateAssessmentOrderDocument, options);
      }
export type CreateAssessmentOrderMutationHookResult = ReturnType<typeof useCreateAssessmentOrderMutation>;
export type CreateAssessmentOrderMutationResult = Apollo.MutationResult<CreateAssessmentOrderMutation>;
export type CreateAssessmentOrderMutationOptions = Apollo.BaseMutationOptions<CreateAssessmentOrderMutation, CreateAssessmentOrderMutationVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    id
    company
    department
    emailFilter
    startTimestamp
    endTimestamp
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const CreateScheduledMessageDocument = gql`
    mutation CreateScheduledMessage($input: ScheduledMessageInput!) {
  createScheduledMessage(input: $input) {
    id
    sendAfter
    fired
    type
    recipients {
      ... on Group {
        company
        id
      }
      ... on User {
        fullName
        uuid
      }
    }
    languages
  }
}
    `;
export type CreateScheduledMessageMutationFn = Apollo.MutationFunction<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>;

/**
 * __useCreateScheduledMessageMutation__
 *
 * To run a mutation, you first call `useCreateScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledMessageMutation, { data, loading, error }] = useCreateScheduledMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>(CreateScheduledMessageDocument, options);
      }
export type CreateScheduledMessageMutationHookResult = ReturnType<typeof useCreateScheduledMessageMutation>;
export type CreateScheduledMessageMutationResult = Apollo.MutationResult<CreateScheduledMessageMutation>;
export type CreateScheduledMessageMutationOptions = Apollo.BaseMutationOptions<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>;
export const DeleteAdminUserDocument = gql`
    mutation DeleteAdminUser($id: String!) {
  deleteAdminUser(id: $id) {
    id
  }
}
    `;
export type DeleteAdminUserMutationFn = Apollo.MutationFunction<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>;

/**
 * __useDeleteAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminUserMutation, { data, loading, error }] = useDeleteAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>(DeleteAdminUserDocument, options);
      }
export type DeleteAdminUserMutationHookResult = ReturnType<typeof useDeleteAdminUserMutation>;
export type DeleteAdminUserMutationResult = Apollo.MutationResult<DeleteAdminUserMutation>;
export type DeleteAdminUserMutationOptions = Apollo.BaseMutationOptions<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>;
export const DeleteScheduledMessagesDocument = gql`
    mutation DeleteScheduledMessages($input: DeleteScheduledMessagesInput!) {
  deleteScheduledMessages(input: $input) {
    ids
  }
}
    `;
export type DeleteScheduledMessagesMutationFn = Apollo.MutationFunction<DeleteScheduledMessagesMutation, DeleteScheduledMessagesMutationVariables>;

/**
 * __useDeleteScheduledMessagesMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledMessagesMutation, { data, loading, error }] = useDeleteScheduledMessagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteScheduledMessagesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledMessagesMutation, DeleteScheduledMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledMessagesMutation, DeleteScheduledMessagesMutationVariables>(DeleteScheduledMessagesDocument, options);
      }
export type DeleteScheduledMessagesMutationHookResult = ReturnType<typeof useDeleteScheduledMessagesMutation>;
export type DeleteScheduledMessagesMutationResult = Apollo.MutationResult<DeleteScheduledMessagesMutation>;
export type DeleteScheduledMessagesMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledMessagesMutation, DeleteScheduledMessagesMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($userUuid: String!) {
  deleteUser(userUuid: $userUuid) {
    userUuid
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetAdminGroupDocument = gql`
    query GetAdminGroup($id: String!, $includeMembers: Boolean!, $includeResourceRoles: Boolean!) {
  adminGroup(id: $id) {
    id
    name
    createdAt
    updatedAt
    members @include(if: $includeMembers) {
      externalRealName
      externalHumanReadableUsername
      id
      adminAuthenticationProviderId
      externalId
    }
    memberCount @include(if: $includeMembers)
    resourceRoles @include(if: $includeResourceRoles) {
      companyGroups {
        roles
        resource {
          id
          company
          department
        }
      }
    }
  }
}
    `;

/**
 * __useGetAdminGroupQuery__
 *
 * To run a query within a React component, call `useGetAdminGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeMembers: // value for 'includeMembers'
 *      includeResourceRoles: // value for 'includeResourceRoles'
 *   },
 * });
 */
export function useGetAdminGroupQuery(baseOptions: Apollo.QueryHookOptions<GetAdminGroupQuery, GetAdminGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminGroupQuery, GetAdminGroupQueryVariables>(GetAdminGroupDocument, options);
      }
export function useGetAdminGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminGroupQuery, GetAdminGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminGroupQuery, GetAdminGroupQueryVariables>(GetAdminGroupDocument, options);
        }
export type GetAdminGroupQueryHookResult = ReturnType<typeof useGetAdminGroupQuery>;
export type GetAdminGroupLazyQueryHookResult = ReturnType<typeof useGetAdminGroupLazyQuery>;
export type GetAdminGroupQueryResult = Apollo.QueryResult<GetAdminGroupQuery, GetAdminGroupQueryVariables>;
export const GetAdminGroupGroupRoleDataDocument = gql`
    query GetAdminGroupGroupRoleData($adminGroupId: String!, $groupId: String!) {
  adminGroup(id: $adminGroupId) {
    id
    name
    resourceRoles {
      companyGroups {
        resourceId
        roles
      }
    }
  }
  group(id: $groupId) {
    company
    department
    id
  }
  availableResourceRoles {
    companyGroups
  }
}
    `;

/**
 * __useGetAdminGroupGroupRoleDataQuery__
 *
 * To run a query within a React component, call `useGetAdminGroupGroupRoleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminGroupGroupRoleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminGroupGroupRoleDataQuery({
 *   variables: {
 *      adminGroupId: // value for 'adminGroupId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetAdminGroupGroupRoleDataQuery(baseOptions: Apollo.QueryHookOptions<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>(GetAdminGroupGroupRoleDataDocument, options);
      }
export function useGetAdminGroupGroupRoleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>(GetAdminGroupGroupRoleDataDocument, options);
        }
export type GetAdminGroupGroupRoleDataQueryHookResult = ReturnType<typeof useGetAdminGroupGroupRoleDataQuery>;
export type GetAdminGroupGroupRoleDataLazyQueryHookResult = ReturnType<typeof useGetAdminGroupGroupRoleDataLazyQuery>;
export type GetAdminGroupGroupRoleDataQueryResult = Apollo.QueryResult<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>;
export const GetAdminGroupsDocument = gql`
    query GetAdminGroups($pagination: PaginationInput, $sort: [SortInput!], $filter: String) {
  adminGroups(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      id
      name
      memberCount
      createdAt
      updatedAt
    }
    meta {
      totalResultCount
    }
  }
}
    `;

/**
 * __useGetAdminGroupsQuery__
 *
 * To run a query within a React component, call `useGetAdminGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAdminGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>(GetAdminGroupsDocument, options);
      }
export function useGetAdminGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>(GetAdminGroupsDocument, options);
        }
export type GetAdminGroupsQueryHookResult = ReturnType<typeof useGetAdminGroupsQuery>;
export type GetAdminGroupsLazyQueryHookResult = ReturnType<typeof useGetAdminGroupsLazyQuery>;
export type GetAdminGroupsQueryResult = Apollo.QueryResult<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>;
export const GetAdminUserDocument = gql`
    query GetAdminUser($id: String!, $includeGlobalRoles: Boolean!, $includeAdminGroups: Boolean!) {
  adminUser(id: $id) {
    id
    externalRealName
    externalHumanReadableUsername
    adminAuthenticationProviderId
    externalOrganizationId
    externalId
    createdAt
    lastAuthenticatedAt
    globalRoles @include(if: $includeGlobalRoles)
    adminGroups @include(if: $includeAdminGroups) {
      data {
        id
        name
      }
    }
    isSuperadmin
  }
}
    `;

/**
 * __useGetAdminUserQuery__
 *
 * To run a query within a React component, call `useGetAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeGlobalRoles: // value for 'includeGlobalRoles'
 *      includeAdminGroups: // value for 'includeAdminGroups'
 *   },
 * });
 */
export function useGetAdminUserQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
      }
export function useGetAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
        }
export type GetAdminUserQueryHookResult = ReturnType<typeof useGetAdminUserQuery>;
export type GetAdminUserLazyQueryHookResult = ReturnType<typeof useGetAdminUserLazyQuery>;
export type GetAdminUserQueryResult = Apollo.QueryResult<GetAdminUserQuery, GetAdminUserQueryVariables>;
export const GetAdminUserEmailsDocument = gql`
    query GetAdminUserEmails($sort: [SortInput!]) {
  adminUsers(sort: $sort) {
    data {
      externalHumanReadableUsername
    }
  }
}
    `;

/**
 * __useGetAdminUserEmailsQuery__
 *
 * To run a query within a React component, call `useGetAdminUserEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserEmailsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAdminUserEmailsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminUserEmailsQuery, GetAdminUserEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserEmailsQuery, GetAdminUserEmailsQueryVariables>(GetAdminUserEmailsDocument, options);
      }
export function useGetAdminUserEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserEmailsQuery, GetAdminUserEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserEmailsQuery, GetAdminUserEmailsQueryVariables>(GetAdminUserEmailsDocument, options);
        }
export type GetAdminUserEmailsQueryHookResult = ReturnType<typeof useGetAdminUserEmailsQuery>;
export type GetAdminUserEmailsLazyQueryHookResult = ReturnType<typeof useGetAdminUserEmailsLazyQuery>;
export type GetAdminUserEmailsQueryResult = Apollo.QueryResult<GetAdminUserEmailsQuery, GetAdminUserEmailsQueryVariables>;
export const GetAdminUsersDocument = gql`
    query GetAdminUsers($pagination: PaginationInput, $sort: [SortInput!], $filter: String, $excludeMembersOfAdminGroup: String, $includeGlobalRoles: Boolean!, $includeAdminGroups: Boolean!) {
  adminUsers(
    pagination: $pagination
    sort: $sort
    filter: $filter
    excludeMembersOfAdminGroup: $excludeMembersOfAdminGroup
  ) {
    data {
      id
      externalRealName
      externalHumanReadableUsername
      adminAuthenticationProviderId
      externalOrganizationId
      createdAt
      lastAuthenticatedAt
      globalRoles @include(if: $includeGlobalRoles)
      adminGroups @include(if: $includeAdminGroups) {
        data {
          id
          name
        }
      }
      isSuperadmin
    }
    meta {
      totalResultCount
    }
  }
}
    `;

/**
 * __useGetAdminUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      excludeMembersOfAdminGroup: // value for 'excludeMembersOfAdminGroup'
 *      includeGlobalRoles: // value for 'includeGlobalRoles'
 *      includeAdminGroups: // value for 'includeAdminGroups'
 *   },
 * });
 */
export function useGetAdminUsersQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
      }
export function useGetAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export type GetAdminUsersQueryHookResult = ReturnType<typeof useGetAdminUsersQuery>;
export type GetAdminUsersLazyQueryHookResult = ReturnType<typeof useGetAdminUsersLazyQuery>;
export type GetAdminUsersQueryResult = Apollo.QueryResult<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const GetAssessmentOrderDocument = gql`
    query GetAssessmentOrder($id: String!, $usersPagination: PaginationInput, $usersSort: [SortInput!], $usersFilter: UserFilterInput) {
  assessmentOrder(id: $id) {
    id
    name
    startTimestamp
    endTimestamp
    surveyMetaModules {
      vid
      key
      surveyModules {
        vid
        key
      }
    }
    groups {
      ...GroupFields
      assessmentOrders {
        id
        surveyCompletedCount
      }
    }
    messages {
      id
      sendAfter
      fired
      type
      recipients {
        ... on Group {
          ...GroupFields
        }
        ... on User {
          uuid
          email
          firstName
          lastName
          fullName
        }
      }
      languages
    }
    users(pagination: $usersPagination, sort: $usersSort, filter: $usersFilter) {
      data {
        ...BasicUserFields
      }
      meta {
        totalResultCount
      }
    }
  }
}
    ${GroupFieldsFragmentDoc}
${BasicUserFieldsFragmentDoc}`;

/**
 * __useGetAssessmentOrderQuery__
 *
 * To run a query within a React component, call `useGetAssessmentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      usersPagination: // value for 'usersPagination'
 *      usersSort: // value for 'usersSort'
 *      usersFilter: // value for 'usersFilter'
 *   },
 * });
 */
export function useGetAssessmentOrderQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>(GetAssessmentOrderDocument, options);
      }
export function useGetAssessmentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>(GetAssessmentOrderDocument, options);
        }
export type GetAssessmentOrderQueryHookResult = ReturnType<typeof useGetAssessmentOrderQuery>;
export type GetAssessmentOrderLazyQueryHookResult = ReturnType<typeof useGetAssessmentOrderLazyQuery>;
export type GetAssessmentOrderQueryResult = Apollo.QueryResult<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>;
export const GetAssessmentOrdersDocument = gql`
    query GetAssessmentOrders($pagination: PaginationInput, $sort: [SortInput!], $filter: AssessmentOrderFilterInput) {
  assessmentOrders(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      id
      name
      startTimestamp
      endTimestamp
      groups {
        id
        company
      }
    }
    meta {
      totalResultCount
    }
  }
}
    `;

/**
 * __useGetAssessmentOrdersQuery__
 *
 * To run a query within a React component, call `useGetAssessmentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentOrdersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAssessmentOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>(GetAssessmentOrdersDocument, options);
      }
export function useGetAssessmentOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>(GetAssessmentOrdersDocument, options);
        }
export type GetAssessmentOrdersQueryHookResult = ReturnType<typeof useGetAssessmentOrdersQuery>;
export type GetAssessmentOrdersLazyQueryHookResult = ReturnType<typeof useGetAssessmentOrdersLazyQuery>;
export type GetAssessmentOrdersQueryResult = Apollo.QueryResult<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>;
export const GetAuthorizationDocument = gql`
    query GetAuthorization($input: AuthorizationRequest!) {
  authorize(input: $input)
}
    `;

/**
 * __useGetAuthorizationQuery__
 *
 * To run a query within a React component, call `useGetAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorizationQuery, GetAuthorizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorizationQuery, GetAuthorizationQueryVariables>(GetAuthorizationDocument, options);
      }
export function useGetAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorizationQuery, GetAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorizationQuery, GetAuthorizationQueryVariables>(GetAuthorizationDocument, options);
        }
export type GetAuthorizationQueryHookResult = ReturnType<typeof useGetAuthorizationQuery>;
export type GetAuthorizationLazyQueryHookResult = ReturnType<typeof useGetAuthorizationLazyQuery>;
export type GetAuthorizationQueryResult = Apollo.QueryResult<GetAuthorizationQuery, GetAuthorizationQueryVariables>;
export const GetAuthorizationForResourceTypesDocument = gql`
    query GetAuthorizationForResourceTypes($input: [AuthorizeResourceTypeRequest!]!) {
  authorizeResourceTypes(input: $input) {
    queryId
    authorized
  }
}
    `;

/**
 * __useGetAuthorizationForResourceTypesQuery__
 *
 * To run a query within a React component, call `useGetAuthorizationForResourceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizationForResourceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizationForResourceTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAuthorizationForResourceTypesQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorizationForResourceTypesQuery, GetAuthorizationForResourceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorizationForResourceTypesQuery, GetAuthorizationForResourceTypesQueryVariables>(GetAuthorizationForResourceTypesDocument, options);
      }
export function useGetAuthorizationForResourceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorizationForResourceTypesQuery, GetAuthorizationForResourceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorizationForResourceTypesQuery, GetAuthorizationForResourceTypesQueryVariables>(GetAuthorizationForResourceTypesDocument, options);
        }
export type GetAuthorizationForResourceTypesQueryHookResult = ReturnType<typeof useGetAuthorizationForResourceTypesQuery>;
export type GetAuthorizationForResourceTypesLazyQueryHookResult = ReturnType<typeof useGetAuthorizationForResourceTypesLazyQuery>;
export type GetAuthorizationForResourceTypesQueryResult = Apollo.QueryResult<GetAuthorizationForResourceTypesQuery, GetAuthorizationForResourceTypesQueryVariables>;
export const GetEndUserAssessmentOrderWithResultsDocument = gql`
    query GetEndUserAssessmentOrderWithResults($userUuid: String!, $assessmentOrderId: String!, $resultId: PositiveInt!, $language: Language!) {
  endUserAssessmentOrder(
    assessmentOrderId: $assessmentOrderId
    userUuid: $userUuid
    language: $language
  ) {
    id
    name
    closed
    personal
    trial
    progressPercentage
    features {
      showResultsToEndUser
      surveyFlowVariant
    }
    result(resultId: $resultId, language: $language) {
      legacyRawResult
      id
      userUuid
      timestamp
      virtaScore
      expired
      completed
      summary(language: $language) {
        content
      }
      strengths(language: $language) {
        title
        intro
        cards {
          id
          header
          content
          icon
        }
      }
      recommendations(language: $language) {
        goal
        title
        intro
        recommendationsForGoal {
          id
          header
          content
          icon
          type
          tag
          feedbackGuide {
            id
            title
            sections {
              id
              content {
                value
              }
            }
          }
        }
      }
    }
    resultHistory(language: $language) {
      legacyRawResult
    }
  }
  user(uuid: $userUuid) {
    uuid
    email
    fullName
  }
}
    `;

/**
 * __useGetEndUserAssessmentOrderWithResultsQuery__
 *
 * To run a query within a React component, call `useGetEndUserAssessmentOrderWithResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndUserAssessmentOrderWithResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndUserAssessmentOrderWithResultsQuery({
 *   variables: {
 *      userUuid: // value for 'userUuid'
 *      assessmentOrderId: // value for 'assessmentOrderId'
 *      resultId: // value for 'resultId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetEndUserAssessmentOrderWithResultsQuery(baseOptions: Apollo.QueryHookOptions<GetEndUserAssessmentOrderWithResultsQuery, GetEndUserAssessmentOrderWithResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndUserAssessmentOrderWithResultsQuery, GetEndUserAssessmentOrderWithResultsQueryVariables>(GetEndUserAssessmentOrderWithResultsDocument, options);
      }
export function useGetEndUserAssessmentOrderWithResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndUserAssessmentOrderWithResultsQuery, GetEndUserAssessmentOrderWithResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndUserAssessmentOrderWithResultsQuery, GetEndUserAssessmentOrderWithResultsQueryVariables>(GetEndUserAssessmentOrderWithResultsDocument, options);
        }
export type GetEndUserAssessmentOrderWithResultsQueryHookResult = ReturnType<typeof useGetEndUserAssessmentOrderWithResultsQuery>;
export type GetEndUserAssessmentOrderWithResultsLazyQueryHookResult = ReturnType<typeof useGetEndUserAssessmentOrderWithResultsLazyQuery>;
export type GetEndUserAssessmentOrderWithResultsQueryResult = Apollo.QueryResult<GetEndUserAssessmentOrderWithResultsQuery, GetEndUserAssessmentOrderWithResultsQueryVariables>;
export const GetGroupDocument = gql`
    query GetGroup($id: String!, $includeAssessmentOrders: Boolean!, $includeResults: Boolean!, $includeUsers: Boolean!, $language: AdminLanguage!, $resultsPagination: PaginationInput, $resultsFilter: ResultFilterInput, $resultsSort: [SortInput!], $usersPagination: PaginationInput, $usersFilter: UserFilterInput, $usersSort: [SortInput!], $orderUsersPagination: PaginationInput, $orderUsersFilter: UserFilterInput, $orderUsersSort: [SortInput!]) {
  group(id: $id) {
    ...GroupFields
    assessmentOrders @include(if: $includeAssessmentOrders) {
      id
      name
      startTimestamp
      endTimestamp
      surveyCompletedCount
      users(
        pagination: $orderUsersPagination
        sort: $orderUsersSort
        filter: $orderUsersFilter
      ) {
        data {
          ...BasicUserFields
          assessmentOrders {
            id
            surveyCompleted
          }
        }
        meta {
          totalResultCount
        }
      }
    }
    results(
      language: $language
      pagination: $resultsPagination
      filter: $resultsFilter
      sort: $resultsSort
    ) @include(if: $includeResults) {
      data {
        ...BasicResultFields
      }
      meta {
        totalResultCount
      }
    }
    users(pagination: $usersPagination, filter: $usersFilter, sort: $usersSort) @include(if: $includeUsers) {
      data {
        ...BasicUserFields
      }
      meta {
        totalResultCount
      }
    }
  }
}
    ${GroupFieldsFragmentDoc}
${BasicUserFieldsFragmentDoc}
${BasicResultFieldsFragmentDoc}`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeAssessmentOrders: // value for 'includeAssessmentOrders'
 *      includeResults: // value for 'includeResults'
 *      includeUsers: // value for 'includeUsers'
 *      language: // value for 'language'
 *      resultsPagination: // value for 'resultsPagination'
 *      resultsFilter: // value for 'resultsFilter'
 *      resultsSort: // value for 'resultsSort'
 *      usersPagination: // value for 'usersPagination'
 *      usersFilter: // value for 'usersFilter'
 *      usersSort: // value for 'usersSort'
 *      orderUsersPagination: // value for 'orderUsersPagination'
 *      orderUsersFilter: // value for 'orderUsersFilter'
 *      orderUsersSort: // value for 'orderUsersSort'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const GetGroupsDocument = gql`
    query GetGroups($pagination: PaginationInput, $sort: [SortInput!], $filter: String) {
  groups(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...GroupFields
    }
    meta {
      totalResultCount
    }
  }
}
    ${GroupFieldsFragmentDoc}`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    globalRoles
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetMultiAuthorizationDocument = gql`
    query GetMultiAuthorization($input: [MultiAuthorizationRequest!]!) {
  authorizeMulti(input: $input) {
    queryId
    authorized
  }
}
    `;

/**
 * __useGetMultiAuthorizationQuery__
 *
 * To run a query within a React component, call `useGetMultiAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiAuthorizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMultiAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<GetMultiAuthorizationQuery, GetMultiAuthorizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultiAuthorizationQuery, GetMultiAuthorizationQueryVariables>(GetMultiAuthorizationDocument, options);
      }
export function useGetMultiAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultiAuthorizationQuery, GetMultiAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultiAuthorizationQuery, GetMultiAuthorizationQueryVariables>(GetMultiAuthorizationDocument, options);
        }
export type GetMultiAuthorizationQueryHookResult = ReturnType<typeof useGetMultiAuthorizationQuery>;
export type GetMultiAuthorizationLazyQueryHookResult = ReturnType<typeof useGetMultiAuthorizationLazyQuery>;
export type GetMultiAuthorizationQueryResult = Apollo.QueryResult<GetMultiAuthorizationQuery, GetMultiAuthorizationQueryVariables>;
export const GetSuperadminAuthorizationDocument = gql`
    query GetSuperadminAuthorization {
  authorizeSuperadmin
}
    `;

/**
 * __useGetSuperadminAuthorizationQuery__
 *
 * To run a query within a React component, call `useGetSuperadminAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuperadminAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuperadminAuthorizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuperadminAuthorizationQuery(baseOptions?: Apollo.QueryHookOptions<GetSuperadminAuthorizationQuery, GetSuperadminAuthorizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuperadminAuthorizationQuery, GetSuperadminAuthorizationQueryVariables>(GetSuperadminAuthorizationDocument, options);
      }
export function useGetSuperadminAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuperadminAuthorizationQuery, GetSuperadminAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuperadminAuthorizationQuery, GetSuperadminAuthorizationQueryVariables>(GetSuperadminAuthorizationDocument, options);
        }
export type GetSuperadminAuthorizationQueryHookResult = ReturnType<typeof useGetSuperadminAuthorizationQuery>;
export type GetSuperadminAuthorizationLazyQueryHookResult = ReturnType<typeof useGetSuperadminAuthorizationLazyQuery>;
export type GetSuperadminAuthorizationQueryResult = Apollo.QueryResult<GetSuperadminAuthorizationQuery, GetSuperadminAuthorizationQueryVariables>;
export const GetSurveyMetaModulesDocument = gql`
    query GetSurveyMetaModules {
  surveyMetaModules {
    vid
    key
    surveyModules {
      vid
      key
    }
  }
}
    `;

/**
 * __useGetSurveyMetaModulesQuery__
 *
 * To run a query within a React component, call `useGetSurveyMetaModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyMetaModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyMetaModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveyMetaModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>(GetSurveyMetaModulesDocument, options);
      }
export function useGetSurveyMetaModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>(GetSurveyMetaModulesDocument, options);
        }
export type GetSurveyMetaModulesQueryHookResult = ReturnType<typeof useGetSurveyMetaModulesQuery>;
export type GetSurveyMetaModulesLazyQueryHookResult = ReturnType<typeof useGetSurveyMetaModulesLazyQuery>;
export type GetSurveyMetaModulesQueryResult = Apollo.QueryResult<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>;
export const GetSurveyQuestionsDocument = gql`
    query GetSurveyQuestions($sort: [SortInput!], $filter: String) {
  surveyQuestions(sort: $sort, filter: $filter) {
    ...SurveyQuestionFields
  }
}
    ${SurveyQuestionFieldsFragmentDoc}`;

/**
 * __useGetSurveyQuestionsQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuestionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSurveyQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveyQuestionsQuery, GetSurveyQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyQuestionsQuery, GetSurveyQuestionsQueryVariables>(GetSurveyQuestionsDocument, options);
      }
export function useGetSurveyQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyQuestionsQuery, GetSurveyQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyQuestionsQuery, GetSurveyQuestionsQueryVariables>(GetSurveyQuestionsDocument, options);
        }
export type GetSurveyQuestionsQueryHookResult = ReturnType<typeof useGetSurveyQuestionsQuery>;
export type GetSurveyQuestionsLazyQueryHookResult = ReturnType<typeof useGetSurveyQuestionsLazyQuery>;
export type GetSurveyQuestionsQueryResult = Apollo.QueryResult<GetSurveyQuestionsQuery, GetSurveyQuestionsQueryVariables>;
export const GetUnlinkedMsAdUsersInAdAdminGroupDocument = gql`
    query GetUnlinkedMsAdUsersInAdAdminGroup {
  unlinkedMsAdUsersInAdAdminGroup {
    id
    userPrincipalName
    displayName
  }
}
    `;

/**
 * __useGetUnlinkedMsAdUsersInAdAdminGroupQuery__
 *
 * To run a query within a React component, call `useGetUnlinkedMsAdUsersInAdAdminGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnlinkedMsAdUsersInAdAdminGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnlinkedMsAdUsersInAdAdminGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnlinkedMsAdUsersInAdAdminGroupQuery(baseOptions?: Apollo.QueryHookOptions<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>(GetUnlinkedMsAdUsersInAdAdminGroupDocument, options);
      }
export function useGetUnlinkedMsAdUsersInAdAdminGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>(GetUnlinkedMsAdUsersInAdAdminGroupDocument, options);
        }
export type GetUnlinkedMsAdUsersInAdAdminGroupQueryHookResult = ReturnType<typeof useGetUnlinkedMsAdUsersInAdAdminGroupQuery>;
export type GetUnlinkedMsAdUsersInAdAdminGroupLazyQueryHookResult = ReturnType<typeof useGetUnlinkedMsAdUsersInAdAdminGroupLazyQuery>;
export type GetUnlinkedMsAdUsersInAdAdminGroupQueryResult = Apollo.QueryResult<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($uuid: String!, $includeGroups: Boolean!, $includeResults: Boolean!, $language: AdminLanguage!, $resultsFilter: ResultFilterInput, $resultsSort: [SortInput!]) {
  user(uuid: $uuid) {
    ...FullUserFields
    groups @include(if: $includeGroups) {
      id
      company
      department
    }
    results(language: $language, filter: $resultsFilter, sort: $resultsSort) @include(if: $includeResults) {
      data {
        ...DetailedResultFields
      }
      meta {
        totalResultCount
      }
    }
  }
}
    ${FullUserFieldsFragmentDoc}
${DetailedResultFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      includeGroups: // value for 'includeGroups'
 *      includeResults: // value for 'includeResults'
 *      language: // value for 'language'
 *      resultsFilter: // value for 'resultsFilter'
 *      resultsSort: // value for 'resultsSort'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($pagination: PaginationInput, $sort: [SortInput!], $filter: String) {
  users(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...BasicUserFields
    }
    meta {
      totalResultCount
    }
  }
}
    ${BasicUserFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GrantResourceRolesToAdminGroupDocument = gql`
    mutation GrantResourceRolesToAdminGroup($input: AdminGroupResourceRolesMutationInput!) {
  grantResourceRolesToAdminGroup(input: $input) {
    adminGroupId
  }
}
    `;
export type GrantResourceRolesToAdminGroupMutationFn = Apollo.MutationFunction<GrantResourceRolesToAdminGroupMutation, GrantResourceRolesToAdminGroupMutationVariables>;

/**
 * __useGrantResourceRolesToAdminGroupMutation__
 *
 * To run a mutation, you first call `useGrantResourceRolesToAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantResourceRolesToAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantResourceRolesToAdminGroupMutation, { data, loading, error }] = useGrantResourceRolesToAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantResourceRolesToAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<GrantResourceRolesToAdminGroupMutation, GrantResourceRolesToAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantResourceRolesToAdminGroupMutation, GrantResourceRolesToAdminGroupMutationVariables>(GrantResourceRolesToAdminGroupDocument, options);
      }
export type GrantResourceRolesToAdminGroupMutationHookResult = ReturnType<typeof useGrantResourceRolesToAdminGroupMutation>;
export type GrantResourceRolesToAdminGroupMutationResult = Apollo.MutationResult<GrantResourceRolesToAdminGroupMutation>;
export type GrantResourceRolesToAdminGroupMutationOptions = Apollo.BaseMutationOptions<GrantResourceRolesToAdminGroupMutation, GrantResourceRolesToAdminGroupMutationVariables>;
export const RemoveAdminUsersFromAdminGroupDocument = gql`
    mutation RemoveAdminUsersFromAdminGroup($input: AdminGroupAdminUserMutationInput!) {
  removeAdminUsersFromAdminGroup(input: $input) {
    removedAdminUserIds
  }
}
    `;
export type RemoveAdminUsersFromAdminGroupMutationFn = Apollo.MutationFunction<RemoveAdminUsersFromAdminGroupMutation, RemoveAdminUsersFromAdminGroupMutationVariables>;

/**
 * __useRemoveAdminUsersFromAdminGroupMutation__
 *
 * To run a mutation, you first call `useRemoveAdminUsersFromAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminUsersFromAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminUsersFromAdminGroupMutation, { data, loading, error }] = useRemoveAdminUsersFromAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminUsersFromAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAdminUsersFromAdminGroupMutation, RemoveAdminUsersFromAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAdminUsersFromAdminGroupMutation, RemoveAdminUsersFromAdminGroupMutationVariables>(RemoveAdminUsersFromAdminGroupDocument, options);
      }
export type RemoveAdminUsersFromAdminGroupMutationHookResult = ReturnType<typeof useRemoveAdminUsersFromAdminGroupMutation>;
export type RemoveAdminUsersFromAdminGroupMutationResult = Apollo.MutationResult<RemoveAdminUsersFromAdminGroupMutation>;
export type RemoveAdminUsersFromAdminGroupMutationOptions = Apollo.BaseMutationOptions<RemoveAdminUsersFromAdminGroupMutation, RemoveAdminUsersFromAdminGroupMutationVariables>;
export const RemoveUsersFromGroupDocument = gql`
    mutation RemoveUsersFromGroup($input: UpdateGroupUsersInput!) {
  removeUsersFromGroup(input: $input) {
    groupId
    userUuids
  }
}
    `;
export type RemoveUsersFromGroupMutationFn = Apollo.MutationFunction<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>;

/**
 * __useRemoveUsersFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromGroupMutation, { data, loading, error }] = useRemoveUsersFromGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUsersFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>(RemoveUsersFromGroupDocument, options);
      }
export type RemoveUsersFromGroupMutationHookResult = ReturnType<typeof useRemoveUsersFromGroupMutation>;
export type RemoveUsersFromGroupMutationResult = Apollo.MutationResult<RemoveUsersFromGroupMutation>;
export type RemoveUsersFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>;
export const RevokeResourceRolesOfAdminGroupDocument = gql`
    mutation RevokeResourceRolesOfAdminGroup($input: AdminGroupResourceRolesMutationInput!) {
  revokeResourceRolesOfAdminGroup(input: $input) {
    adminGroupId
  }
}
    `;
export type RevokeResourceRolesOfAdminGroupMutationFn = Apollo.MutationFunction<RevokeResourceRolesOfAdminGroupMutation, RevokeResourceRolesOfAdminGroupMutationVariables>;

/**
 * __useRevokeResourceRolesOfAdminGroupMutation__
 *
 * To run a mutation, you first call `useRevokeResourceRolesOfAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeResourceRolesOfAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeResourceRolesOfAdminGroupMutation, { data, loading, error }] = useRevokeResourceRolesOfAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeResourceRolesOfAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<RevokeResourceRolesOfAdminGroupMutation, RevokeResourceRolesOfAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeResourceRolesOfAdminGroupMutation, RevokeResourceRolesOfAdminGroupMutationVariables>(RevokeResourceRolesOfAdminGroupDocument, options);
      }
export type RevokeResourceRolesOfAdminGroupMutationHookResult = ReturnType<typeof useRevokeResourceRolesOfAdminGroupMutation>;
export type RevokeResourceRolesOfAdminGroupMutationResult = Apollo.MutationResult<RevokeResourceRolesOfAdminGroupMutation>;
export type RevokeResourceRolesOfAdminGroupMutationOptions = Apollo.BaseMutationOptions<RevokeResourceRolesOfAdminGroupMutation, RevokeResourceRolesOfAdminGroupMutationVariables>;
export const SendInvitationEmailDocument = gql`
    mutation SendInvitationEmail($userUuid: String!) {
  sendInvitationEmail(userUuid: $userUuid) {
    userUuid
  }
}
    `;
export type SendInvitationEmailMutationFn = Apollo.MutationFunction<SendInvitationEmailMutation, SendInvitationEmailMutationVariables>;

/**
 * __useSendInvitationEmailMutation__
 *
 * To run a mutation, you first call `useSendInvitationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationEmailMutation, { data, loading, error }] = useSendInvitationEmailMutation({
 *   variables: {
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useSendInvitationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendInvitationEmailMutation, SendInvitationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvitationEmailMutation, SendInvitationEmailMutationVariables>(SendInvitationEmailDocument, options);
      }
export type SendInvitationEmailMutationHookResult = ReturnType<typeof useSendInvitationEmailMutation>;
export type SendInvitationEmailMutationResult = Apollo.MutationResult<SendInvitationEmailMutation>;
export type SendInvitationEmailMutationOptions = Apollo.BaseMutationOptions<SendInvitationEmailMutation, SendInvitationEmailMutationVariables>;
export const UpdateAdminGroupDocument = gql`
    mutation UpdateAdminGroup($id: String!, $input: UpdateAdminGroupInput!) {
  updateAdminGroup(id: $id, input: $input) {
    name
  }
}
    `;
export type UpdateAdminGroupMutationFn = Apollo.MutationFunction<UpdateAdminGroupMutation, UpdateAdminGroupMutationVariables>;

/**
 * __useUpdateAdminGroupMutation__
 *
 * To run a mutation, you first call `useUpdateAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminGroupMutation, { data, loading, error }] = useUpdateAdminGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminGroupMutation, UpdateAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminGroupMutation, UpdateAdminGroupMutationVariables>(UpdateAdminGroupDocument, options);
      }
export type UpdateAdminGroupMutationHookResult = ReturnType<typeof useUpdateAdminGroupMutation>;
export type UpdateAdminGroupMutationResult = Apollo.MutationResult<UpdateAdminGroupMutation>;
export type UpdateAdminGroupMutationOptions = Apollo.BaseMutationOptions<UpdateAdminGroupMutation, UpdateAdminGroupMutationVariables>;
export const UpdateAssessmentOrderDocument = gql`
    mutation UpdateAssessmentOrder($id: String!, $input: UpdateAssessmentOrderInput!) {
  updateAssessmentOrder(id: $id, input: $input) {
    id
    name
    startTimestamp
    endTimestamp
  }
}
    `;
export type UpdateAssessmentOrderMutationFn = Apollo.MutationFunction<UpdateAssessmentOrderMutation, UpdateAssessmentOrderMutationVariables>;

/**
 * __useUpdateAssessmentOrderMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentOrderMutation, { data, loading, error }] = useUpdateAssessmentOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssessmentOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentOrderMutation, UpdateAssessmentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentOrderMutation, UpdateAssessmentOrderMutationVariables>(UpdateAssessmentOrderDocument, options);
      }
export type UpdateAssessmentOrderMutationHookResult = ReturnType<typeof useUpdateAssessmentOrderMutation>;
export type UpdateAssessmentOrderMutationResult = Apollo.MutationResult<UpdateAssessmentOrderMutation>;
export type UpdateAssessmentOrderMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentOrderMutation, UpdateAssessmentOrderMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($id: String!, $input: UpdateGroupInput!) {
  updateGroup(id: $id, input: $input) {
    id
    company
    department
    emailFilter
    startTimestamp
    endTimestamp
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    uuid
    firstName
    lastName
    email
    dateOfBirth
    gender
    phoneNumber
    language
    trialExpireAt
    groups {
      id
      company
      department
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpsertUsersDocument = gql`
    mutation UpsertUsers($input: UpsertUsersInput!) {
  upsertUsers(input: $input) {
    email
    firstName
    lastName
    fullName
    uuid
  }
}
    `;
export type UpsertUsersMutationFn = Apollo.MutationFunction<UpsertUsersMutation, UpsertUsersMutationVariables>;

/**
 * __useUpsertUsersMutation__
 *
 * To run a mutation, you first call `useUpsertUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUsersMutation, { data, loading, error }] = useUpsertUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertUsersMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUsersMutation, UpsertUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUsersMutation, UpsertUsersMutationVariables>(UpsertUsersDocument, options);
      }
export type UpsertUsersMutationHookResult = ReturnType<typeof useUpsertUsersMutation>;
export type UpsertUsersMutationResult = Apollo.MutationResult<UpsertUsersMutation>;
export type UpsertUsersMutationOptions = Apollo.BaseMutationOptions<UpsertUsersMutation, UpsertUsersMutationVariables>;